import { render, staticRenderFns } from "./V3Agent.vue?vue&type=template&id=5ac6639e&"
import script from "./V3Agent.vue?vue&type=script&lang=js&"
export * from "./V3Agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports